import React, { useEffect } from 'react';
import Rodal from '../Rodal/Rodal';
import { ModalBody, ModalHeader } from 'reactstrap';
import './LegalDocumentInformationPopup.scss';
import { useStateSelector } from '../../store/selectors';
import { PrefilledTags } from '../../models/PrefilledTags/PrefilledTags';
import { DataNdaLegalInformationForm } from './LegalInformationForms/DataNdaLegalInformationForm';
import { ActionDocumentType } from '../../slices/marketplace/timeline/models/enums/action-document-type.enum';
import { IdNdaLegalInformationForm } from './LegalInformationForms/IdNdaLegalInformationForm';

interface LegalDocumentInformationPopupProps {
    onClose(): void;
    onSubmit(documentInfo: PrefilledTags[]): void;
    isLoading?: boolean;
    documentType: ActionDocumentType;
    opportunityId: number;
}

const LegalDocumentInformationPopup = (
    props: LegalDocumentInformationPopupProps
) => {
    const targetBuyerProfile = useStateSelector(
        (s) => s.buyersState.targetBuyer.profile
    );

    return (
        <div className="legal-document-information-popup">
            <Rodal
                visible={true}
                onClose={() => {
                    if (!props.isLoading) {
                        props.onClose();
                    }
                }}
                width={600}
                showMask={false}>
                <ModalHeader>
                    {'Confirm Legal Document Information'}
                </ModalHeader>
                <ModalBody>
                    {props.documentType === ActionDocumentType.IdNda ? (
                        <IdNdaLegalInformationForm
                            onClose={props.onClose}
                            onSubmit={props.onSubmit}
                            isLoading={props.isLoading}
                            buyerProfile={targetBuyerProfile}
                            opportunityId={
                                props.opportunityId
                            }></IdNdaLegalInformationForm>
                    ) : (
                        <DataNdaLegalInformationForm
                            onClose={props.onClose}
                            onSubmit={props.onSubmit}
                            buyerProfile={targetBuyerProfile}
                            opportunityId={props.opportunityId}
                            isLoading={
                                props.isLoading
                            }></DataNdaLegalInformationForm>
                    )}
                </ModalBody>
            </Rodal>
        </div>
    );
};

export default LegalDocumentInformationPopup;
